export const defaultLogoUrl = "/images/logo-mark.png";
export const defaultFaviconUrl = "/static/image/favicon.ico";

export function setDocumentFavicon(url: string) {
  const href = url.trim() || defaultFaviconUrl;
  const existing = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  const link = existing || document.createElement("link");

  link.rel = "icon";
  link.href = href;
  link.type = href.toLowerCase().endsWith(".ico") ? "image/x-icon" : "image/png";

  if (!existing) {
    document.head.appendChild(link);
  }
}
